const PROD_CONFIG = {"REACT_APP_USER_POOL_ID":"us-west-2_5LoDKkgnL",
    "REACT_APP_USER_POOL_WEB_CLIENT_ID":"72vur1dp3m5larlrp3vjvl9rhc",
    "REACT_APP_COGNITO_DOMAIN":"cog-approvermatrix-na-prod.auth.us-west-2.amazoncognito.com",
    "REACT_APP_REDIRECT_URL":"https://checkpoint.lab126.amazon.dev",
    "REACT_APP_API_ENDPOINT":"https://sw6pgdqvi3.execute-api.us-west-2.amazonaws.com/Prod/"}

export default PROD_CONFIG
